<template>
  <div class="report-filter-page col-block default-shadow" :style="{ height: minHeight }">
    <div v-if="disabled" class="mask"></div>
    <div class="title-container center-block">
      <div class="title">{{ title }}</div>
    </div>
    <div class="filter-container">
      <customFilter
        :init="init"
        :filters="filters.options"
        @change="conditions => filtersOnChange(conditions)"
        @pressEnter="() => updateFilter()"
      ></customFilter>
      <div class="button col-block">
        <button type="button" name="button" class="main-button" @click="e => updateFilter()">
          <span>搜尋</span>
        </button>
        <div :style="{ height: '15px' }"></div>
        <button type="button" name="button" class="white-button" @click="e => clearFilter()">
          <span>清除</span>
        </button>
      </div>
      <div :style="{ height: '20px' }"></div>
      <div class="tutorial-link" @click="e => $router.push({ name: 'tutorial', query: { to: '分析報告與操作說明' } })">•<span class="link">分析報告與操作說明</span></div>
    </div>
    <div class="other-container col-block" :style="{ flex: 1 }">
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import customFilter from '../tool/customFilter'

export default {
  components: {
    customFilter
  },
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      init: {},
      conditions: {
        filters: {}
      }
    }
  },
  created () {
    this.init = this.filters.init
  },
  watch: {
    'filters' () {
      this.init = this.filters.init
    }
  },
  methods: {
    filtersOnChange (conditions) {
      // const init = !Object.values(this.conditions.filters).every(x => x)
      this.conditions.filters = conditions
      this.updateFilter(false)
    },
    updateFilter (search = true, value = null) {
      this.$emit('changeFilters', JSON.parse(JSON.stringify(value || this.conditions.filters)), search)
    },
    clearFilter () {
      this.init = {}
      setTimeout(() => this.updateFilter(true, {}))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/filter.vue